const PropTypes = require('prop-types');
// @ vendors
const React = require('react');

// @ utilities
const { getFormattedString } = require('utilities/currencyHelper');
const { getCardAvailableBalance } = require('utilities/cardsHelper');

// @ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { LoadingDots } = require('commonsComponents/loadingDots');

class CardPrepaidBalance extends React.Component {
    prepaidBalance() {
        const { immCard, loading } = this.props;
        if (loading) {
            return <LoadingDots inline color="dark" size="small" />;
        }
        return getFormattedString(getCardAvailableBalance(immCard));
    }

    render() {
        return (
            <OKInformativeList title="cardDetails-prepaidBalanceTitle">
                <OKInformativeListItem
                    title="cardDetails-prepaidBalance"
                    children={this.prepaidBalance()}
                />
            </OKInformativeList>
        );
    }
}

CardPrepaidBalance.propTypes = {
    loading: PropTypes.bool,
    immCard: PropTypes.object.isRequired
};

CardPrepaidBalance.DefaultProps = {
    loading: false
}

module.exports = CardPrepaidBalance;
